// app/features/billingProfile/billingProfileSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BillingProfile {
  id: string;
  user_id: string;
  billing_name: string;
  billing_email: string;
  billing_phone: string;
  postal_code: string;
  state: string;
  city: string;
  line1: string;
  line2: string;
  stripe_customer_id: string;
  created_at: string;
  updated_at: string;
}

interface BillingProfileState {
  data: BillingProfile | null;
  loading: boolean;
  error: string | null;
}

const initialState: BillingProfileState = {
  data: null,
  loading: false,
  error: null,
};

const billingProfileSlice = createSlice({
  name: "billingProfile",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    fetchBillingProfileStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBillingProfileSuccess(state, action: PayloadAction<BillingProfile>) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchBillingProfileFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateBillingProfile(state, action: PayloadAction<Partial<BillingProfile>>) {
      if (state.data) {
        state.data = { ...state.data, ...action.payload };
      }
    },
    resetBillingProfileLoading(state) {
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchBillingProfileStart,
  fetchBillingProfileSuccess,
  fetchBillingProfileFailure,
  updateBillingProfile,
  resetBillingProfileLoading,
  setLoading,
  setError,
} = billingProfileSlice.actions;

export default billingProfileSlice.reducer;